import { Box, Typography } from '@mui/material';
import { PERMISSIONS } from '@vy/types';
import { FC } from 'react';
import { ClickToEditTextCell } from '../../../../../../../../components/custom-fields/ClickToEditTextCell';
import { renderWithPermissions } from '../../../../../../../../services/render-with-permissions';

type EditableMemberNameCellProps = {
  value: string;
  dataVyPrefix: string;
  onCommit: (nextValue: string) => void;
};

export const EditableMemberNameCell: FC<EditableMemberNameCellProps> = ({ value, dataVyPrefix, onCommit }) =>
  renderWithPermissions([PERMISSIONS.USER_UPDATE], (hasPermission) => {
    if (!hasPermission) {
      return <Typography variant="body2">{value}</Typography>;
    }

    return (
      <Box onKeyDown={(e) => e.stopPropagation()} sx={{ width: '100%' }}>
        <ClickToEditTextCell
          valueType="String"
          value={value}
          onCommit={(nextValue) => {
            const nextString = String(nextValue ?? '');

            if (nextString !== value) {
              onCommit(nextString);
            }
          }}
          onBlur={() => undefined}
          dataVyPrefix={dataVyPrefix}
          showConfirmButtons
        />
      </Box>
    );
  }) as React.ReactElement;
